import React from "react";
import "./HeaderButton.css";

type Props = {
  onClick?: (id: string) => void;
  label: string;
  icon?: React.ReactNode;
  content?: React.ReactNode;
  style?: React.CSSProperties;
  id: string;
  moreAction?: boolean;
  disabled?: boolean;
};

const moreActionIcon = (
  <svg width="12" height="6" viewBox="0 0 12 6" fill="none">
    <path d="M5.99999 6L0 0H12L5.99999 6Z" fill="white" />
  </svg>
);

export default function HeaderButton({
  onClick = () => {},
  label,
  icon,
  content,
  style = {},
  id,
  moreAction = false,
  disabled = false,
}: Props) {
  if (content == null && icon == null) {
    throw new Error("Both content and icon cannot be null");
  }

  return (
    <button
      style={{
        ...style,
      }}
      key={id}
      id={id}
      className={"header-button"}
      disabled={disabled}
      onClick={() => {
        if (!disabled) onClick(id);
      }}
    >
      {content ? (
        <div className="header-button-content">{content}</div>
      ) : (
        <div className="header-button-icon">{icon}</div>
      )}
      <div className="header-button-label">{label}</div>
      {moreAction && <div className="header-button-more">{moreActionIcon}</div>}
    </button>
  );
}
